import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoggerProvider } from '@shared';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { DiscardDraftQuery } from './discard-draft.query';

@Injectable({ providedIn: 'root' })
export class DiscardDraftUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);
  private readonly _logger = inject(LoggerProvider).createScoped('DiscardDraftUseCase');

  public execute(query: DiscardDraftQuery): Observable<void> {
    this._state.setLoadingInvestigationForm(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.discardDraft(query.formId).pipe(
      tap(() => this._logger.info('Discarded draft', { formId: query.formId })),
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to discard draft for form ${query.formId}`;
        this._state.setErrorInvestigationForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingInvestigationForm(false))
    );
  }
}
